import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

// Native app only: lock viewport zoom so pinch gestures can't scale the UI.
// The web build keeps maximum-scale=5 (index.html) for accessibility zoom.
if (Capacitor.isNativePlatform()) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
    );
}

// Clear caches on Android app start to ensure fresh UI
if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
  // Keep the WebView below the status bar and match the app's dark chrome.
  // Android 15 edge-to-edge is opted out natively (values-v35/styles.xml);
  // these calls cover older Android versions and re-assert bar styling.
  StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
  StatusBar.setBackgroundColor({ color: '#0a0a0f' }).catch(() => {});
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {});

  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        if (cacheName.startsWith('digitalvault-')) {
          caches.delete(cacheName);
        }
      });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
